import { useRef } from 'react';
import { useSelector } from 'react-redux';
import pick from 'lodash/pick';

// Components
import QuestionItem from 'app/components/tests/questions/QuestionItem';
import QuestionTable from 'app/components/tests/questions/QuestionTable';
import AudioPlayer from 'app/components/tests/media/AudioPlayer';

// Constants and Types
import { AppStoreState } from 'app/redux/store';
import { Group, Question } from 'types/test';

interface GroupQuestionProps {
  group: Group;
  groupResult: Group | null;
  handleChange: (value: string | null, question: Question) => void;
  confirmIsReady: () => void;
}

const GroupQuestion = ({ group, groupResult, handleChange, confirmIsReady }: GroupQuestionProps) => {
  const audioPlayer = useRef<any>(undefined);
  const { currentPage } = useSelector((state: AppStoreState) => state.test);

  return (
    <div className={`group-question mt-4 ${group?.page === currentPage ? 'd-block' : 'd-none'}`}>
      <AudioPlayer group={group} ref={audioPlayer} />
      <div className="col-12 d-block">
        <QuestionTable
          groupType={group.group_type}
          groupOptions={group.options || ''}
        />
        {(group?.list_question || []).map((question: Question, index: number) => (
          <QuestionItem
            key={question.id}
            question={question}
            group={pick(group, ['group_type', 'category_id', 'part_id', 'options'])}
            questionResult={groupResult ? groupResult?.list_question[index] : null}
            handleChange={handleChange}
            confirmIsReady={confirmIsReady}
            audioPlayer={audioPlayer}
          />
        ))}
      </div>
    </div>
  );
};

export default GroupQuestion;
